<cc-msisdn [msisdn]="number"></cc-msisdn>
<div class="edit-tool grey-text">
  <mat-chip-list>
    <mat-chip
      *ngIf="number.eea"
      (click)="setMainEeaPhoneNumber.next(number)"
      [class.active]="number.mainEeaPhoneNumber">
      <span translate>PHONE_NUMBERS.EEA_PHONE_NUMBER</span>
    </mat-chip>
    <mat-chip
      [class.active]="number.mainPhoneNumber"
      (click)="setMainPhoneNumber.next(number)">
      <span translate>PHONE_NUMBERS.MAIN_PHONE_NUMBER</span>
    </mat-chip>
  </mat-chip-list>
  <i
    class="material-icons h-1 edit-tool-settings"
    (click)="onEdit()">settings</i>
  <i
    class="material-icons h-1"
    (click)="removePhoneNumber.next(number.id)">delete</i>
</div>
